import React from 'react';
import RadarChart from './graph_components/RadarChart';
import SelectedActorsScores from './graph_components/ActorScoreBoard';
import SelectedActorsScoresCG from './graph_components/ActorSimpleScoreDisplay';
import CBSScore from './graph_components/CBSScoreChart';
import WaterFootprintGraph from './graph_components/WaterFootprintGraph';
import MapComponent from './graph_components/MapFootprint';
import SimpleGauge from './graph_components/SimpleGauge';
import WaterHistogramChart from './graph_components/WaterHistogramChart';
import BeforeAfterDoughnut from './graph_components/BeforeAfterDoughnut';
import { beforeAfterSeries } from './beforeAfter';

// Rendu d'une liste de composants graphiques (content.list_graph : [{component_id,
// metadata}]), partage entre les pages de type "score" (ScoreBoard.js) et les
// etapes de type "graph" d'un module territory_intro — meme forme, meme rendu,
// pour ne pas dupliquer ce switch une troisieme fois.
//
// Les cartes sont celles du TABLEAU DE BORD (`.board-*`, App.css), partagées
// avec les trois bilans de fin. Elles remplacent `score-board-grid-large`, dont
// le `min-width` valait 80 % de la largeur d'écran : une carte y imposait la
// largeur de sa page, et débordait du panneau latéral d'un module territoire.
const GraphGrid = ({ listGraph, gameStatus, editMode = false, onEditGraphItem, onAddGraphItem }) => {
  const series = beforeAfterSeries(listGraph, gameStatus?.score_dic);
  return (
    <div className="board-grid">
      {(listGraph || []).map((item, index) => {
        let content;
        switch (item.component_id) {
          case "radar_chart":
            content = <RadarChart gameStatus={gameStatus} selectedMetrics={item.metadata.selected_metrics}
                                  width="100%" height="380px" />;
            break;
          case "waterfootprint_score":
            content = <WaterFootprintGraph gameStatus={gameStatus} phaseFocus={item.metadata.phase_focus} />;
            break;
          case "cbs_score":
            content = <CBSScore gameStatus={gameStatus} />;
            break;
          case "actor_pannel":
            content = <SelectedActorsScores gameStatus={gameStatus}></SelectedActorsScores>;
            break;
          case "aware_map":
            content = <MapComponent />;
            break;
          case "simple_gauge":
            content = <SimpleGauge gameStatus={gameStatus} selectedMetric={item.metadata.key} />;
            break;
          case "water_histogram":
            // Le graphe d'entre deux tours : c'est ici, et pas dans le bilan
            // de fin, que la courbe d'objectif dit si la salle est sur la
            // bonne voie. `target_per_round` de l'item surcharge l'atelier.
            content = <WaterHistogramChart gameStatus={gameStatus} showObjective
                                           targetPerRound={item.metadata?.target_per_round} />;
            break;
          case "actor_pannel_cg":
            content = <SelectedActorsScoresCG gameStatus={gameStatus} />;
            break;
          case "before_after_doughnut":
            content = <BeforeAfterDoughnut series={series[index]} scoreId={item.metadata?.score_id} />;
            break;
          default:
            content = null; // Ne rien afficher si l'ID ne correspond pas
        }
        return (
          <div key={index} className={`board-card board-card--wide ${editMode ? 'builder-editable-card' : ''}`}>
            {editMode && (
              <button
                className="builder-edit-fab builder-edit-fab-card"
                onClick={() => onEditGraphItem(index)}
                title="Modifier ce composant graphique"
              >✏️</button>
            )}
            {content}
          </div>
        );
      })}
      {editMode && (
        <div className="board-card board-card--wide builder-add-card" onClick={onAddGraphItem} title="Ajouter un composant graphique">
          <span className="builder-add-card-plus">+</span>
          <span>Ajouter un composant</span>
        </div>
      )}
    </div>
  );
};

export default GraphGrid;
